/**
 * ImportPreviewStatusDot — indicador visual de status (pontinho colorido + label preta).
 *
 * Padrão usado em todos os previews de importação (Contatos, Negócios, Afiliados).
 *
 * RELEASE:
 *   2026-05-17 v1.0.0 - Componente compartilhado.
 */
import { cn } from '@/lib/utils';

interface ImportPreviewStatusDotProps {
  /** Cor Tailwind do ponto (ex.: 'bg-emerald-500'). */
  colorClass: string;
  label: string;
}

export function ImportPreviewStatusDot({ colorClass, label }: ImportPreviewStatusDotProps) {
  return (
    <div className="flex items-center gap-1.5">
      <span className={cn('h-1.5 w-1.5 rounded-full shrink-0', colorClass)} />
      <span className="text-foreground">{label}</span>
    </div>
  );
}
